/* Native behavior for the imported homepage markup; no legacy builder runtime. */
(() => {
  const instances = new WeakMap();
  const initialize = (root = document) => {
    root.querySelectorAll('.sk-pi-slideshow').forEach((gallery) => {
      if (instances.has(gallery)) return;
      const slides = [...gallery.querySelectorAll('.sk-pi-slide')];
      if (slides.length < 2) return;
      const abort = new AbortController();
      const options = { signal: abort.signal };
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0;
      let timer;
      let paused = reducedMotion.matches;
      const pauseButton = gallery.querySelector('.seed-slideshow-pause');
      const updatePause = () => {
        if (!pauseButton) return;
        pauseButton.setAttribute('aria-pressed', String(paused));
        pauseButton.textContent = paused ? pauseButton.dataset.play : pauseButton.dataset.pause;
      };
      const show = (next) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.style.opacity = i === index ? '1' : '0';
          slide.style.pointerEvents = i === index ? 'auto' : 'none';
          slide.setAttribute('aria-hidden', String(i !== index));
        });
      };
      const stop = () => clearInterval(timer);
      const start = () => {
        stop();
        if (!paused && !document.hidden) timer = setInterval(() => show(index + 1), 3000);
      };
      gallery.querySelector('.sk-pi-inside-prev')?.addEventListener('click', () => { show(index - 1); start(); }, options);
      gallery.querySelector('.sk-pi-inside-next')?.addEventListener('click', () => { show(index + 1); start(); }, options);
      pauseButton?.addEventListener('click', () => { paused = !paused; updatePause(); start(); }, options);
      gallery.addEventListener('pointerenter', stop, options);
      gallery.addEventListener('pointerleave', start, options);
      gallery.addEventListener('focusin', stop, options);
      gallery.addEventListener('focusout', start, options);
      document.addEventListener('visibilitychange', start, options);
      reducedMotion.addEventListener('change', () => { paused = reducedMotion.matches; updatePause(); start(); }, options);
      updatePause();
      show(0);
      start();
      instances.set(gallery, () => { stop(); abort.abort(); });
    });
    root.querySelectorAll('#fm_mobile_menu_toggler').forEach((toggle) => {
      if (toggle.dataset.seedBound) return;
      toggle.dataset.seedBound = 'true';
      toggle.addEventListener('click', () => {
        const expanded = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(expanded));
        const menu = document.getElementById('fm_menu');
        menu?.classList.toggle('fmMenuSelected', expanded);
      });
    });
  };
  initialize();
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.sk-pi-slideshow').forEach((gallery) => instances.get(gallery)?.());
  });
})();
